import styled from 'styled-components';

interface Props {
  height: number;
}

export const FixedHeight = styled.div<Props>`
  height: ${({ height }) => height}px;
`;
